// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3IGEo","footer":"Form_footer__2KKW1"};